'use client';

import { memo } from 'react';
import PropTypes from 'prop-types';

import isNewConsumerApp from 'commons/isNewConsumerApp';
import useIsBrowser from 'hooks/useIsBrowser';
import useScreen from 'hooks/useScreen';

const TabletAndDesktopOnly = ({ children, fallback = null }) => {
  const isBrowser = useIsBrowser();
  const { isTabletOrDesktop } = useScreen();

  // In new Consumer app, to prevent SSR bug always render on server. After components
  // are mounted in browser, we should conditionally only render when on a tablet or desktop device.
  return (isNewConsumerApp && !isBrowser) || isTabletOrDesktop
    ? children
    : fallback;
};

TabletAndDesktopOnly.propTypes = {
  children: PropTypes.node,
};

export default memo(TabletAndDesktopOnly);
